import { Controller } from '@hotwired/stimulus';
import { fireChangeEvent } from '../search/accordion_change';

export default class NumberRangeBaseController extends Controller {
  static targets = ['from', 'to'];
  static values = { unit: String };

  connect() {
    fireChangeEvent(this.element, this._getDisplayText());
  }

  onChange() {
    this._swapValuesIfToLowerThanFrom();
    fireChangeEvent(this.element, this._getDisplayText());
  }

  _swapValuesIfToLowerThanFrom() {
    if (!this.fromTarget.dataset.rawValue || !this.toTarget.dataset.rawValue) {
      return;
    }

    if (Number.parseFloat(this.fromTarget.dataset.rawValue) > Number.parseFloat(this.toTarget.dataset.rawValue)) {
      const oldToValue = this.toTarget.value;
      const oldToRawValue = this.toTarget.dataset.rawValue;
      this.toTarget.value = this.fromTarget.value;
      this.toTarget.dataset.rawValue = this.fromTarget.dataset.rawValue;
      this.fromTarget.value = oldToValue;
      this.fromTarget.dataset.rawValue = oldToRawValue;
    }
  }

  _getUnit() {
    return this.unitValue ?? '';
  }

  _getDisplayText() {
    const values = [];
    if (this.fromTarget.value) {
      values.push(`min: ${this.fromTarget.value} ${this._getUnit()}`);
    }
    if (this.toTarget.value) {
      values.push(`max: ${this.toTarget.value} ${this._getUnit()}`);
    }
    if (values.length === 0) {
      return null;
    }
    return values.join(', ');
  }
}
